import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tel.png'
import _imports_1 from '@/assets/Mail.png'
import _imports_2 from '@/assets/Map.png'


const _withScopeId = n => (_pushScopeId("data-v-4eca8be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "TumiPopUp text-center"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "TumiTel pt-3 pb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "35",
  alt: "tel"
}, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { href: "mailto:info@garagedevuyst.be" }
const _hoisted_7 = { class: "TumiMail pt-3 pb-3 border-top" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "35",
  alt: "tel"
}, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "ps-1"
}
const _hoisted_10 = { class: "row g-0 border-top" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "70",
  alt: "map"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ONS VINDEN ")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "row g-0 text-center border-top align-items-center pt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, " OPENINGSUREN ", -1))
const _hoisted_17 = { class: "col-6 TumiHeures" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" MA-VR")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 TumiHeures TumiDroite" }, [
  /*#__PURE__*/_createTextVNode(" ZA & ZO"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" GESLOTEN ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 pt-3 pb-3 border-top" }, " BE 0467.151.604 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "button" }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Show && _ctx.Show(...args))),
          class: "btn btn-primary"
        }, " Contact ")
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (_ctx.showPopUp && _ctx.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Show && _ctx.Show(...args)))
              }, " x "),
              _createElementVNode("a", {
                href: 'tel:' + _ctx.content.CONTENT_NUMMER
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  (_ctx.content.CONTENT_NUMMER)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.content.CONTENT_NUMMER), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_2),
              _createElementVNode("a", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.content.CONTENT_EMAIL)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.content.CONTENT_EMAIL), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "col-12 TumiCursor pt-3 pb-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Scroll(4)))
                }, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19,
                  (_ctx.content.CONTENT_OPENINGSURENAM)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.content.CONTENT_OPENINGSURENAM), 1))
                    : _createCommentVNode("", true),
                  _hoisted_21,
                  (_ctx.content.CONTENT_OPENINGSURENPM)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.content.CONTENT_OPENINGSURENPM), 1))
                    : _createCommentVNode("", true),
                  _hoisted_23
                ]),
                _hoisted_24
              ]),
              _hoisted_25
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}